import Highcharts from 'highcharts';

export const figure61 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 180,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#deebf7', '#9dc3e6', '#5b9bd5'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
	    hover: {
			   enabled: true,
			   radius: 5
		   }
    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
categories: [
	     "العالم",
	     "",
	     "أمريكا الشمالية وأوروبا الغربية",
	     "أمريكا اللاتينية ومنطقة البحر الكاريبي",
	     "غرب آسيا وشمال أفريقيا",
	     "أفريقيا جنوب الصحراء",
	     "آسيا الوسطى وجنوب آسيا",
	     "أستراليا ونيوزيلندا",
	     "شرق آسيا وجنوب شرق آسيا",
	     "أوقيانوسيا باستثناء أستراليا ونيوزيلندا",
	     "",
	     "البلدان النامية غير الساحلية",
	     "الدول الجزرية الصغيرة النامية",
	     "أقل البلدان نموًا",
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
useHTML: true,
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
		format: '{value:.1f}',
		formatter: function () {
	    // should be return this.value + '.00%'; but doesn't fit
				return this.value + '%';
			},		
style: {
	   fontWeight: 'normal',
	   color: '#999999',
	   fontSize: '12px'
   },
},
max: 2.0,
min: 0,
tickInterval: 0.2,
gridLineWidth: 0,
title: {
text: null,
style: {
	 color: Highcharts.getOptions().colors[1]
 }
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
	      enabled: true,
	      format: '{point.label}', // Display the label
style: {
	  fontWeight: 'normal',
	  textOutline: false,
	  color: '#999999',
	  fontSize: '12px'
  }
},
data: [
       0.100,
       { y: 0 },
       0.026,
       0.076,
       0.231,
       0.429,
       0.246,
       0.578,
       0.912,
       1.627,
       { y: 0 },
       { y: 0 },
       0.498,
       1.244,
],
},
{
name: '2017',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
	      enabled: true,
	      format: '{point.label}', // Display the label
style: {
	  fontWeight: 'normal',
	  textOutline: false,
	  color: '#999999',
	  fontSize: '12px'
  }
},
data: [
       0.103,
       { y: 0 },
       0.028,
       0.096,
       0.251,
       0.505,
       0.247,
       0.566,
       0.805,
       1.609,
       { y: 0 },
       { y: 0 },
       0.507,
       1.202,
]
},
{
	name: '2019',
	      tooltip: {
		      valueSuffix: '%'
	      },
	      dataLabels: {
		      enabled: true,
		      format: '{point.label}', // Display the label
		      style: {
				       fontWeight: 'normal',
				       textOutline: false,
				       color: '#999999',
				       fontSize: '12px'
			       }
	      },
	      data: [
		     0.097,
		     { y: 0 },
		     0.025,
		     0.090,
		     0.224,
		     0.381,
		     0.208,
		     0.513,
		     0.796,
		     1.542,
		     { y: 0 },
		     { y: 0, label: 'لا ينطبق' },
		     0.459,
		     0.882
		    ]
}	]
}
